import { render } from "./EditProjectPage.vue?vue&type=template&id=2c558f52&scoped=true"
import script from "./EditProjectPage.vue?vue&type=script&lang=js"
export * from "./EditProjectPage.vue?vue&type=script&lang=js"

import "./EditProjectPage.vue?vue&type=style&index=0&id=2c558f52&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c558f52"]])

export default __exports__